import React from 'react';
import { LuArrowRight } from 'react-icons/lu';
import { fueOtraCosa } from '../../utils/pedidoVsHecho';

// Lo que pidió la empresa y lo que se hizo, uno arriba del otro (28-oct-2026). Si fue otra cosa
// (pidieron limpieza y se retiró el equipo) va en ámbar con "Fue otro trabajo".
export default function PedidoVsHecho({ pedido, hecho }) {
    if (!pedido || !hecho) return null;
    const otra = fueOtraCosa(pedido, hecho);
    return (
        <div className={`rounded-2xl px-4 py-3 space-y-2 ${otra ? 'bg-[rgba(217,119,6,0.12)] border border-[#D97706]/40' : 'bg-panel'}`}>
            {otra && <p className="text-caption font-black uppercase tracking-wide text-[#B45309] dark:text-[#F0A500]">Fue otro trabajo</p>}
            <div className="flex items-start gap-3">
                <span className="w-20 shrink-0 text-caption text-muted pt-0.5">Pidieron</span>
                <span className={`flex-1 text-body font-bold ${otra ? 'text-secondary' : 'text-ink'}`}>{pedido}</span>
            </div>
            <div className="flex items-start gap-3">
                <span className="w-20 shrink-0 text-caption text-muted pt-0.5 inline-flex items-center gap-1">Se hizo {otra && <LuArrowRight size={12} />}</span>
                <span className="flex-1 text-body font-black text-ink">{hecho}</span>
            </div>
        </div>
    );
}
